import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getData, serverURL } from "../../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS (optimized sizes)
// ─────────────────────────────────────────────────────────────────────────────
const EditIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
const TrashIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
const SearchIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
const ChevronLeftIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>);
const ChevronRightIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>);
const PlusIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const ViewMoreIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>);
const CheckCircleIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>);
const XCircleIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>);
const PowerIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>);
const ShieldCheckIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>);
const ShieldOffIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="8" x2="12" y2="14"/><line x1="9" y1="11" x2="15" y2="11"/></svg>);
const BackIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const OnlineIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/><path d="M4 4l2 2"/><path d="M20 4l-2 2"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// IMAGE COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const DriverImage = ({ picName, name, theme }) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  const getImageUrl = () => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    if (filename.includes('\\')) {
      filename = filename.split('\\').pop();
    }
    return `${serverURL}/public/uploadnew/upload/${filename}`;
  };
  
  const imageUrl = getImageUrl();
  
  if (!imageUrl || imageError) {
    const initial = name ? name.charAt(0).toUpperCase() : "D";
    return (
      <div style={{ 
        width: "32px", 
        height: "32px", 
        borderRadius: "50%", 
        background: "linear-gradient(135deg, #3b82f6, #8b5cf6)", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        fontSize: "13px", 
        fontWeight: 600, 
        color: "#fff" 
      }}>
        {initial}
      </div>
    );
  }
  
  return (
    <img 
      src={imageUrl}
      alt={name}
      onError={() => { setImageError(true); setIsLoading(false); }}
      onLoad={() => setIsLoading(false)}
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        objectFit: "cover",
        border: `1px solid ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}`
      }}
    />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, theme }) => {
  const isActive = status === "Active";
  const config = { 
    Active: { bg: "rgba(20,184,166,0.15)", color: "#14b8a6", dot: "#14b8a6" }, 
    Inactive: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8", dot: "#94a3b8" } 
  };
  const c = config[status] || config.Inactive;
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 8px 2px 6px", borderRadius: "16px", background: c.bg, border: `1px solid ${c.bg}` }}>
      <div style={{ width: "4px", height: "4px", borderRadius: "50%", background: c.dot }} />
      <span style={{ fontSize: "9px", fontWeight: 600, color: c.color }}>{status}</span>
    </div>
  );
};

const ReadyBadge = ({ is_ready, theme }) => {
  const ready = is_ready === "1" ? "Yes" : "No";
  const config = { 
    Yes: { bg: "rgba(20,184,166,0.15)", color: "#14b8a6" }, 
    No: { bg: "rgba(245,158,11,0.12)", color: "#f59e0b" } 
  };
  const c = config[ready] || config.No;
  return <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "9px", fontWeight: 600, background: c.bg, color: c.color }}>{ready}</span>;
};

const OnOffBadge = ({ open_status, theme }) => {
  const value = open_status === "1" ? "ON" : "OFF";
  const config = { 
    ON: { bg: "rgba(34,197,94,0.15)", color: "#22c55e" }, 
    OFF: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8" } 
  };
  const c = config[value] || config.OFF;
  return <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "9px", fontWeight: 700, background: c.bg, color: c.color }}>{value}</span>;
};

const VerificationBadge = ({ driver, theme }) => {
  const isVerified = driver.is_verify_personalinfo === "1" && driver.is_verify_docinfo === "1" && driver.is_verify_vehicle === "1" && driver.is_verify_bankinfo === "1" && driver.is_verify_emergency === "1";
  return <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "9px", fontWeight: 600, background: isVerified ? "rgba(20,184,166,0.15)" : "rgba(245,158,11,0.12)", color: isVerified ? "#14b8a6" : "#f59e0b" }}>{isVerified ? "Verified" : "Pending"}</span>;
};

const Checkbox = ({ checked, onChange, theme }) => {
  const borderColor = checked ? "#3b82f6" : (theme === 'dark' ? "#3a4460" : "#d1d5db");
  return (
    <div onClick={onChange} style={{ 
      width: "14px", height: "14px", borderRadius: "3px", 
      border: checked ? "2px solid #3b82f6" : `2px solid ${borderColor}`, 
      background: checked ? "#3b82f6" : "transparent", 
      display: "flex", alignItems: "center", justifyContent: "center", 
      cursor: "pointer", transition: "all 0.15s ease" 
    }}>
      {checked && (
        <svg width="8" height="8" viewBox="0 0 12 12" fill="none">
          <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )}
    </div>
  );
};

const Toast = ({ message, type, onClose, theme }) => {
  return (
    <div style={{ 
      position: "fixed", bottom: "24px", right: "24px", zIndex: 999, 
      background: type === "error" ? (theme === 'dark' ? "#1a0a0a" : "#fef2f2") : (theme === 'dark' ? "#0a1a0a" : "#f0fdf4"), 
      border: `1px solid ${type === "error" ? "rgba(239,68,68,0.4)" : "rgba(16,185,129,0.4)"}`, 
      borderRadius: "10px", padding: "10px 16px", 
      display: "flex", alignItems: "center", gap: "8px", 
      boxShadow: theme === 'dark' ? "0 8px 32px rgba(0,0,0,0.5)" : "0 8px 32px rgba(0,0,0,0.1)", 
      animation: "slideUp 0.25s ease" 
    }}>
      <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: type === "error" ? "#ef4444" : "#10b981" }} />
      <span style={{ fontSize: "12px", color: type === "error" ? (theme === 'dark' ? "#fca5a5" : "#dc2626") : (theme === 'dark' ? "#6ee7b7" : "#059669"), flex: 1 }}>{message}</span>
      <span onClick={onClose} style={{ cursor: "pointer", color: "#64748b", fontSize: "14px" }}>×</span>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT - DriverTable
// ─────────────────────────────────────────────────────────────────────────────
const DriverTable = ({ isDark = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = isDark ? 'dark' : 'light';
  
  const colors = {
    background: isDark ? "#0d1117" : "#f9fafb",
    surface: isDark ? "#141824" : "#ffffff",
    surfaceHover: isDark ? "rgba(255,255,255,0.025)" : "rgba(0,0,0,0.02)",
    surfaceLighter: isDark ? "#1a2035" : "#f3f4f6",
    border: isDark ? "#1e2740" : "#e5e7eb",
    borderLight: isDark ? "#1a2035" : "#f3f4f6",
    textPrimary: isDark ? "#f1f5f9" : "#111827",
    textSecondary: isDark ? "#94a3b8" : "#6b7280",
    textMuted: isDark ? "#64748b" : "#9ca3af",
    inputBg: isDark ? "#0f1520" : "#f9fafb",
    inputBorder: isDark ? "#1e2740" : "#e5e7eb",
    selectedBg: isDark ? "rgba(59,130,246,0.07)" : "rgba(79,70,229,0.05)",
    buttonPrimaryBg: isDark ? "#1e3a8a" : "#eef2ff",
    buttonPrimaryColor: isDark ? "#93c5fd" : "#4f46e5",
    modalBg: isDark ? "#141824" : "#ffffff",
    modalBorder: isDark ? "#1e2740" : "#e5e7eb",
    deleteBg: isDark ? "rgba(239,68,68,0.15)" : "#fef2f2",
    deleteColor: "#ef4444",
    addBtnBg: "#4a6cf7",
    exportBtnBg: "#28a745",
    filterBtnActiveBg: "#3b82f6",
    filterBtnActiveColor: "#fff",
    filterBtnInactiveBg: "transparent",
    filterBtnInactiveColor: isDark ? "#64748b" : "#6b7280",
    filterBtnInactiveBorder: isDark ? "#1e2740" : "#e5e7eb",
    tableHeaderBg: isDark ? "#0f1520" : "#f9fafb",
    tableRowBorder: isDark ? "#1a2035" : "#f3f4f6",
  };
  
  // State
  const [drivers, setDrivers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [readyFilter, setReadyFilter] = useState("All");
  const [onOffFilter, setOnOffFilter] = useState("All");
  const [selected, setSelected] = useState(new Set());
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [toast, setToast] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  
  // Pre-filtered data state
  const [isPreFiltered, setIsPreFiltered] = useState(false);
  const [filterTitle, setFilterTitle] = useState("");
  const [filterType, setFilterType] = useState("");

  const showToast = (message, type = "success") => { 
    setToast({ message, type }); 
    setTimeout(() => setToast(null), 3500); 
  };

  const handlePerPageChange = (e) => {
    const newPerPage = parseInt(e.target.value);
    setPerPage(newPerPage);
    setPage(1);
  };

  const handleBack = () => {
    navigate("/Dashboard");
  };

  useEffect(() => { 
    const t = setTimeout(() => { 
      setDebouncedSearch(search); 
      setPage(1); 
    }, 500); 
    return () => clearTimeout(t); 
  }, [search]);

  const fetchDrivers = useCallback(async () => {
    setLoading(true);
    try {
      // Check if we have pre-filtered data from navigation
      const state = location.state;
      console.log("📍 DriverTable - Location state:", state);
      
      if (state && state.data && state.data.length > 0) {
        console.log("✅ Received pre-filtered driver data from Dashboard:", state);
        console.log("✅ Number of drivers:", state.data.length);
        
        // Sort pre-filtered data in decreasing order
        const sortedData = [...state.data].sort((a, b) => {
          if (a.created_at && b.created_at) {
            return new Date(b.created_at) - new Date(a.created_at);
          }
          return parseInt(b.id) - parseInt(a.id);
        });
        
        setDrivers(sortedData);
        setTotal(sortedData.length);
        setIsPreFiltered(true);
        setFilterTitle(state.title || "Online Riders");
        setFilterType(state.type || "online");
        setLoading(false);
        return;
      }
      
      // Otherwise fetch from API
      const res = await getData("drivers/Riders");
      console.log("API Response:", res);
      
      let driversData = [];
      if (res && res.status === true) {
        driversData = res.data || [];
      } else if (Array.isArray(res)) {
        driversData = res;
      } else if (res && res.drivers && Array.isArray(res.drivers)) {
        driversData = res.drivers;
      } else if (res && res.data && Array.isArray(res.data)) {
        driversData = res.data;
      } else {
        driversData = [];
      }
      
      // ✅ SORT IN DECREASING ORDER (NEWEST FIRST)
      driversData = driversData.sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        return parseInt(b.id) - parseInt(a.id);
      });
      
      setDrivers(driversData);
      setTotal(driversData.length);
      setIsPreFiltered(false);
      setFilterTitle("");
      setFilterType("");
    } catch (error) {
      console.error("Fetch drivers error:", error);
      showToast(`Failed to load drivers: ${error.message}`, "error");
      setDrivers([]);
      setTotal(0);
    } finally { 
      setLoading(false); 
    }
  }, [location.state]);

  useEffect(() => { 
    fetchDrivers(); 
  }, [fetchDrivers]);

  // Apply search across ALL columns
  const applySearch = (driver, searchTerm) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase().trim();
    
    const searchableFields = [
      driver.id?.toString() || "",
      driver.name || "",
      driver.first_name || "",
      driver.last_name || "",
      driver.displayName || "",
      driver.contact || "",
      driver.primary_number || "",
      driver.whatsapp_number || "",
      driver.email || "",
      driver.address || "",
      driver.city || "",
      driver.state || "",
      driver.postal || "",
      driver.bank_name || "",
      driver.account_number || "",
      driver.ifsc || "",
      driver.wallet || "",
      driver.is_ready === "1" ? "ready" : "",
      driver.is_ready === "0" ? "not ready" : "",
      driver.open_status === "1" ? "on" : "",
      driver.open_status === "0" ? "off" : "",
      driver.status === "1" ? "active" : "",
      driver.status === "0" ? "inactive" : "",
      driver.gender || "",
      driver.blood_group || "",
    ];
    
    return searchableFields.some(field => 
      field && field.toString().toLowerCase().includes(term)
    );
  };

  // Apply filters
  let filteredDrivers = [...drivers];
  
  if (statusFilter !== "All") {
    filteredDrivers = filteredDrivers.filter(d => 
      statusFilter === "Active" ? d.status === "1" : d.status !== "1"
    );
  }
  
  if (readyFilter !== "All") {
    filteredDrivers = filteredDrivers.filter(d => 
      readyFilter === "Yes" ? d.is_ready === "1" : d.is_ready !== "1"
    );
  }
  
  if (onOffFilter !== "All") {
    filteredDrivers = filteredDrivers.filter(d => 
      onOffFilter === "ON" ? d.open_status === "1" : d.open_status !== "1"
    );
  }
  
  if (debouncedSearch) {
    filteredDrivers = filteredDrivers.filter(driver => applySearch(driver, debouncedSearch));
  }
  
  const startIndex = (page - 1) * perPage;
  const paginatedDrivers = filteredDrivers.slice(startIndex, startIndex + perPage);
  const totalFiltered = filteredDrivers.length;
  const totalPages = Math.ceil(totalFiltered / perPage);

  // ✅ SN IN DECREASING ORDER - NEWEST FIRST GETS HIGHEST SN
  const mappedDrivers = paginatedDrivers.map((d, idx) => ({ 
    ...d, 
    sn: totalFiltered - startIndex - idx,  // Decreasing order: total, total-1, total-2, ...
    displayName: d.name || `${d.first_name || ''} ${d.last_name || ''}`.trim() || `Driver ${d.id}`,
    displayWallet: `₹${parseFloat(d.wallet || 0).toLocaleString()}`,
    displayDate: d.created_at ? new Date(d.created_at).toLocaleDateString('en-IN') : d.rd || 'N/A',
    statusText: d.status === "1" ? "Active" : "Inactive",
    is_ready: d.is_ready || "0",
    open_status: d.open_status || "0",
    contact: d.contact || d.primary_number || d.whatsapp_number || 'N/A',
  }));

  const pageIds = mappedDrivers.map(d => d.id?.toString());
  const allPageSelected = pageIds.length > 0 && pageIds.every(id => selected.has(id));
  
  const toggleAll = () => { 
    setSelected(prev => { 
      const next = new Set(prev); 
      if (allPageSelected) {
        pageIds.forEach(id => next.delete(id));
      } else {
        pageIds.forEach(id => next.add(id));
      }
      return next; 
    }); 
  };
  
  const toggleOne = (id) => { 
    setSelected(prev => { 
      const n = new Set(prev); 
      if (n.has(id)) {
        n.delete(id);
      } else {
        n.add(id);
      }
      return n; 
    }); 
  };
  
  const clearSelection = () => setSelected(new Set());

  // ─────────────────────────────────────────────────────────────────────────────
  // BULK ACTIONS
  // ─────────────────────────────────────────────────────────────────────────────

  const handleBulkAction = async (action) => {
    if (selected.size === 0) {
      showToast("Please select at least one driver", "error");
      return;
    }

    setActionLoading(true);
    try {
      const ids = Array.from(selected);
      console.log(`Performing ${action} on:`, ids);
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      showToast(`${selected.size} driver(s) ${action} successfully`);
      
      const updatedDrivers = drivers.map(d => {
        if (ids.includes(d.id?.toString())) {
          switch(action) {
            case 'activated':
              return { ...d, status: '1' };
            case 'deactivated':
              return { ...d, status: '0' };
            case 'set ready':
              return { ...d, is_ready: '1', open_status: '1' };
            case 'unset ready':
              return { ...d, is_ready: '0', open_status: '0' };
            case 'turned ON':
              return { ...d, open_status: '1' };
            case 'turned OFF':
              return { ...d, open_status: '0' };
            default:
              return d;
          }
        }
        return d;
      });
      setDrivers(updatedDrivers);
      
      clearSelection();
    } catch (err) {
      showToast(`Failed to ${action}: ${err.message}`, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleAddDriverNavigate = () => {
    navigate("/Dashboard/AddNewDriver", { state: { mode: "add" } });
  };

  const handleEditDriverNavigate = (driver) => {
    navigate("/Dashboard/AddNewDriver", { state: { mode: "edit", driverData: driver } });
  };

  const handleViewMoreClick = (driver) => {
    navigate("/Dashboard/DriverDetails", { state: { driver } });
  };

  const handleDeleteSelected = async () => {
    if (selected.size === 0) return;
    setActionLoading(true);
    try { 
      showToast(`${selected.size} driver(s) deleted`); 
      clearSelection(); 
      setConfirmDelete(false); 
      fetchDrivers(); 
    } catch (err) { 
      showToast(`Delete failed: ${err.message}`, "error"); 
    } finally { 
      setActionLoading(false); 
    }
  };

  // Function to go to last page
  const goToLastPage = () => {
    if (totalPages > 0) {
      setPage(totalPages);
    }
  };

  // Function to go to first page
  const goToFirstPage = () => {
    setPage(1);
  };

  const exportToCSV = () => {
    const headers = ['SN', 'ID', 'Status', 'Date', 'Ready', 'ON/OFF', 'Driver Name', 'Contact', 'Verified', 'Wallet'];
    const csvData = mappedDrivers.map(d => [
      d.sn, d.id, d.statusText, d.displayDate, d.is_ready === "1" ? "Yes" : "No", 
      d.open_status === "1" ? "ON" : "OFF", d.displayName, d.contact, 
      (d.is_verify_personalinfo === "1" && d.is_verify_docinfo === "1" && d.is_verify_vehicle === "1" && d.is_verify_bankinfo === "1" && d.is_verify_emergency === "1") ? "Yes" : "No", 
      d.displayWallet
    ]);
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `drivers_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showToast("Exported successfully");
  };

  // Column widths
  const columnWidths = {
    checkbox: "32px",
    sn: "40px",
    id: "50px",
    pic: "44px",
    status: "70px",
    date: "85px",
    ready: "55px",
    onoff: "55px",
    name: "120px",
    contact: "95px",
    verification: "75px",
    wallet: "75px",
    actions: "85px"
  };

  const styles = {
    container: { minHeight: "100vh", background: colors.background, fontFamily: "'DM Sans', sans-serif", padding: "16px 20px" },
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px", flexWrap: "wrap", gap: "12px" },
    headerLeft: { display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" },
    backBtn: { display: "flex", alignItems: "center", gap: "6px", padding: "6px 14px", borderRadius: "8px", border: `1px solid ${colors.border}`, background: "transparent", color: colors.textSecondary, cursor: "pointer", fontSize: "12px", transition: "all 0.2s" },
    filterBadge: { display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", border: isDark ? "1px solid rgba(34,197,94,0.2)" : "1px solid rgba(34,197,94,0.15)" },
    title: { fontSize: "18px", fontWeight: 700, color: colors.textPrimary, margin: 0 },
    subtitle: { fontSize: "11px", color: colors.textMuted, marginTop: "2px" },
    headerActions: { display: "flex", gap: "10px", flexWrap: "wrap" },
    addBtn: { background: colors.addBtnBg, color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "12px", display: "flex", alignItems: "center", gap: "5px" },
    exportBtn: { background: colors.exportBtnBg, color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "12px" },
    filtersBar: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px", flexWrap: "wrap", gap: "12px" },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "280px" },
    searchInput: { width: "100%", padding: "8px 10px 8px 32px", background: colors.inputBg, border: `1px solid ${colors.inputBorder}`, borderRadius: "8px", fontSize: "12px", color: colors.textPrimary, outline: "none" },
    searchIcon: { position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    filterControls: { display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" },
    filterGroup: { display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: colors.textMuted },
    filterButtons: { display: "flex", gap: "4px" },
    filterBtn: (isActive) => ({ 
      padding: "3px 8px", borderRadius: "5px", fontSize: "11px", 
      background: isActive ? colors.filterBtnActiveBg : colors.filterBtnInactiveBg, 
      color: isActive ? colors.filterBtnActiveColor : colors.filterBtnInactiveColor, 
      border: isActive ? `1px solid ${colors.filterBtnActiveBg}` : `1px solid ${colors.filterBtnInactiveBorder}`, 
      cursor: "pointer" 
    }),
    tableWrapper: { background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: "12px", overflow: "hidden", width: "100%" },
    table: { width: "100%", borderCollapse: "collapse", tableLayout: "fixed" },
    th: (width) => ({ 
      padding: "10px 6px", textAlign: "left", fontSize: "10px", fontWeight: 700, 
      color: "#3b82f6", borderBottom: `1px solid ${colors.border}`, 
      background: colors.tableHeaderBg, width: width || "auto", whiteSpace: "nowrap" 
    }),
    td: { 
      padding: "8px 6px", borderBottom: `1px solid ${colors.tableRowBorder}`, 
      fontSize: "11px", color: colors.textPrimary, whiteSpace: "nowrap", 
      overflow: "hidden", textOverflow: "ellipsis" 
    },
    pagination: { 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "space-between", 
      padding: "10px 16px", 
      borderTop: `1px solid ${colors.border}`, 
      background: colors.tableHeaderBg, 
      flexWrap: "wrap", 
      gap: "10px" 
    },
    viewMoreBtn: { 
      background: colors.surfaceLighter, border: `1px solid ${colors.border}`, 
      borderRadius: "6px", padding: "4px 10px", cursor: "pointer", 
      display: "flex", alignItems: "center", gap: "4px", fontSize: "10px", 
      fontWeight: 500, color: colors.textPrimary, whiteSpace: "nowrap" 
    },
    selectionBar: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      background: isDark 
        ? "linear-gradient(135deg, rgba(59,130,246,0.12), rgba(139,92,246,0.08))" 
        : "linear-gradient(135deg, rgba(59,130,246,0.06), rgba(139,92,246,0.04))",
      border: isDark 
        ? "1px solid rgba(59,130,246,0.25)" 
        : "1px solid rgba(59,130,246,0.15)",
      borderRadius: "12px",
      padding: "10px 16px",
      marginBottom: "14px",
      flexWrap: "wrap",
      backdropFilter: "blur(8px)",
      boxShadow: isDark 
        ? "0 4px 20px rgba(59,130,246,0.08)" 
        : "0 4px 20px rgba(59,130,246,0.06)",
      animation: "slideDown 0.3s ease",
      position: "relative",
      overflow: "hidden",
    },
    actionButtons: {
      display: "flex",
      gap: "6px",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center",
    },
    actionBtn: (color, bgColor) => ({
      padding: "5px 12px",
      borderRadius: "6px",
      border: "none",
      background: bgColor || "rgba(59,130,246,0.12)",
      color: color || "#3b82f6",
      fontSize: "10px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      position: "relative",
      overflow: "hidden",
    }),
    rowsPerPageSelect: {
      padding: "2px 20px 2px 8px",
      borderRadius: "4px",
      border: `1px solid ${isDark ? "#1e2740" : "#e5e7eb"}`,
      background: isDark ? "#141824" : "#ffffff",
      color: isDark ? "#f1f5f9" : "#111827",
      fontSize: "10px",
      cursor: "pointer",
      outline: "none",
      appearance: "auto",
      fontFamily: "'DM Sans', sans-serif",
      height: "24px"
    },
    countBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "2px 10px",
      borderRadius: "12px",
      fontSize: "10px",
      fontWeight: 600,
      background: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)",
      color: "#3b82f6"
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button 
          key={i} 
          onClick={() => setPage(i)} 
          style={{ 
            width: "26px", height: "26px", borderRadius: "5px", 
            border: page === i ? `1px solid #3b82f6` : `1px solid ${colors.border}`, 
            background: page === i ? colors.buttonPrimaryBg : colors.surface, 
            color: page === i ? colors.buttonPrimaryColor : colors.textSecondary, 
            cursor: "pointer", fontSize: "10px" 
          }}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes slideUp { from{transform:translateY(16px);opacity:0} to{transform:translateY(0);opacity:1} } 
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        input::placeholder { color: ${isDark ? "#3a4a6b" : "#9ca3af"}; }
        .action-btn {
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }
        .action-btn:disabled { opacity: 0.5; cursor: not-allowed !important; }
        .action-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at center, rgba(255,255,255,0.15), transparent);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }
        .action-btn:hover::after { opacity: 1; }
        .action-btn:active { transform: scale(0.95) !important; }
        .clear-btn {
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .clear-btn:hover { 
          background: ${isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)"} !important; 
          color: ${isDark ? "#f1f5f9" : "#0f172a"} !important; 
        }
        @media (max-width: 1200px) { .driver-table { font-size: 10px; } }
      `}</style>

      {/* Header with Back Button */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <button style={styles.backBtn} onClick={handleBack}>
            <BackIcon /> Back
          </button>
          <div>
            <h1 style={styles.title}>
              {isPreFiltered ? filterTitle : "Drivers"}
            </h1>
            <p style={styles.subtitle}>
              {isPreFiltered 
                ? `Showing ${drivers.length} ${filterTitle.toLowerCase()}`
                : "Manage and track all delivery drivers"}
            </p>
          </div>
          {isPreFiltered && (
            <span style={styles.filterBadge}>
              <OnlineIcon /> {drivers.length} Online
            </span>
          )}
          {!isPreFiltered && (
            <span style={styles.countBadge}>
              Total: {drivers.length} Drivers
            </span>
          )}
        </div>
        <div style={styles.headerActions}>
          <button style={styles.exportBtn} onClick={exportToCSV}>
            📊 Export CSV
          </button>
          <button style={styles.addBtn} onClick={handleAddDriverNavigate}>
            <PlusIcon /> Add Driver
          </button>
        </div>
      </div>

      <div style={styles.filtersBar}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input 
            type="text" 
            style={styles.searchInput} 
            placeholder="Search by Name, ID, Contact, City, Bank..." 
            value={search} 
            onChange={(e) => setSearch(e.target.value)} 
          />
        </div>
        <div style={styles.filterControls}>
          <div style={styles.filterGroup}>
            <label>Status:</label>
            <div style={styles.filterButtons}>
              <button style={styles.filterBtn(statusFilter === "All")} onClick={() => { setStatusFilter("All"); setPage(1); }}>All</button>
              <button style={styles.filterBtn(statusFilter === "Active")} onClick={() => { setStatusFilter("Active"); setPage(1); }}>Active</button>
              <button style={styles.filterBtn(statusFilter === "Inactive")} onClick={() => { setStatusFilter("Inactive"); setPage(1); }}>Inactive</button>
            </div>
          </div>
          <div style={styles.filterGroup}>
            <label>Ready:</label>
            <div style={styles.filterButtons}>
              <button style={styles.filterBtn(readyFilter === "All")} onClick={() => { setReadyFilter("All"); setPage(1); }}>All</button>
              <button style={styles.filterBtn(readyFilter === "Yes")} onClick={() => { setReadyFilter("Yes"); setPage(1); }}>Yes</button>
              <button style={styles.filterBtn(readyFilter === "No")} onClick={() => { setReadyFilter("No"); setPage(1); }}>No</button>
            </div>
          </div>
          <div style={styles.filterGroup}>
            <label>ON/OFF:</label>
            <div style={styles.filterButtons}>
              <button style={styles.filterBtn(onOffFilter === "All")} onClick={() => { setOnOffFilter("All"); setPage(1); }}>All</button>
              <button style={styles.filterBtn(onOffFilter === "ON")} onClick={() => { setOnOffFilter("ON"); setPage(1); }}>ON</button>
              <button style={styles.filterBtn(onOffFilter === "OFF")} onClick={() => { setOnOffFilter("OFF"); setPage(1); }}>OFF</button>
            </div>
          </div>
        </div>
      </div>

      {/* Selection Bar */}
      {selected.size > 0 && (
        <div style={styles.selectionBar}>
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(90deg, transparent, rgba(59,130,246,0.05), transparent)",
            animation: "shimmer 3s infinite",
            pointerEvents: "none",
          }} />
          
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            paddingRight: "14px",
            borderRight: `1px solid ${isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)"}`,
            flexShrink: 0,
          }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: 700,
              color: "#fff",
              boxShadow: "0 2px 8px rgba(59,130,246,0.3)",
            }}>
              {selected.size}
            </div>
            <div>
              <span style={{
                fontSize: "13px",
                fontWeight: 600,
                color: isDark ? "#f1f5f9" : "#0f172a",
              }}>
                Driver{selected.size > 1 ? "s" : ""} Selected
              </span>
              <span style={{
                fontSize: "10px",
                color: isDark ? "#94a3b8" : "#64748b",
                display: "block",
                marginTop: "-1px",
              }}>
                {selected.size === 1 ? "Click actions below to manage" : `${selected.size} items ready for bulk action`}
              </span>
            </div>
          </div>
          
          <div style={styles.actionButtons}>
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('activated')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#059669", "rgba(16,185,129,0.12)"),
                border: "1px solid rgba(16,185,129,0.2)",
              }}
            >
              <CheckCircleIcon /> Activate
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('deactivated')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#dc2626", "rgba(239,68,68,0.12)"),
                border: "1px solid rgba(239,68,68,0.2)",
              }}
            >
              <XCircleIcon /> Deactivate
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('set ready')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#0d9488", "rgba(20,184,166,0.12)"),
                border: "1px solid rgba(20,184,166,0.2)",
              }}
            >
              <ShieldCheckIcon /> Set Ready
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('unset ready')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#d97706", "rgba(245,158,11,0.12)"),
                border: "1px solid rgba(245,158,11,0.2)",
              }}
            >
              <ShieldOffIcon /> Unset Ready
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('turned ON')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#16a34a", "rgba(34,197,94,0.12)"),
                border: "1px solid rgba(34,197,94,0.2)",
              }}
            >
              <PowerIcon /> Turn ON
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('turned OFF')}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#6b7280", "rgba(148,163,184,0.12)"),
                border: "1px solid rgba(148,163,184,0.2)",
              }}
            >
              <PowerIcon /> Turn OFF
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => setConfirmDelete(true)}
              disabled={actionLoading}
              style={{
                ...styles.actionBtn("#dc2626", "rgba(239,68,68,0.15)"),
                border: "1px solid rgba(239,68,68,0.25)",
                fontWeight: 700,
              }}
            >
              <TrashIcon /> Delete
            </button>
          </div>
          
          <button 
            onClick={clearSelection} 
            className="clear-btn"
            style={{
              padding: "4px 12px",
              borderRadius: "6px",
              border: isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
              background: "transparent",
              color: isDark ? "#94a3b8" : "#64748b",
              fontSize: "11px",
              fontWeight: 500,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Clear
          </button>
        </div>
      )}

      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th(columnWidths.checkbox)}><Checkbox checked={allPageSelected} onChange={toggleAll} theme={theme} /></th>
                <th style={styles.th(columnWidths.sn)}>SN</th>
                <th style={styles.th(columnWidths.id)}>ID</th>
                <th style={styles.th(columnWidths.pic)}>Pic</th>
                <th style={styles.th(columnWidths.status)}>Status</th>
                <th style={styles.th(columnWidths.date)}>Date</th>
                <th style={styles.th(columnWidths.ready)}>Ready</th>
                <th style={styles.th(columnWidths.onoff)}>ON/OFF</th>
                <th style={styles.th(columnWidths.name)}>Driver Name</th>
                <th style={styles.th(columnWidths.contact)}>Contact</th>
                <th style={styles.th(columnWidths.verification)}>Verification</th>
                <th style={styles.th(columnWidths.wallet)}>Wallet</th>
                <th style={styles.th(columnWidths.actions)}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: perPage }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 13 }).map((_, j) => (
                      <td key={j} style={styles.td}>
                        <div style={{ height: "10px", background: colors.border, borderRadius: "3px", width: j === 0 ? "12px" : "70%" }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : mappedDrivers.length === 0 ? (
                <tr>
                  <td colSpan={13} style={{ padding: "50px", textAlign: "center", color: colors.textMuted, fontSize: "12px" }}>
                    {isPreFiltered ? `No ${filterTitle.toLowerCase()} found` : debouncedSearch ? `No drivers found matching "${debouncedSearch}"` : "No drivers found"}
                  </td>
                </tr>
              ) : (
                mappedDrivers.map((driver) => (
                  <tr key={driver.id} style={{ background: selected.has(driver.id?.toString()) ? colors.selectedBg : "transparent" }}>
                    <td style={styles.td}><Checkbox checked={selected.has(driver.id?.toString())} onChange={() => toggleOne(driver.id?.toString())} theme={theme} /></td>
                    <td style={styles.td}>{driver.sn}</td>
                    <td style={styles.td}>{driver.id}</td>
                    <td style={styles.td}>
                      <DriverImage 
                        picName={driver.pic} 
                        name={driver.displayName} 
                        theme={theme} 
                      />
                    </td>
                    <td style={styles.td}><StatusBadge status={driver.statusText} theme={theme} /></td>
                    <td style={styles.td}>{driver.displayDate}</td>
                    <td style={styles.td}><ReadyBadge is_ready={driver.is_ready} theme={theme} /></td>
                    <td style={styles.td}><OnOffBadge open_status={driver.open_status} theme={theme} /></td>
                    <td style={styles.td}><strong style={{ fontSize: "11px" }}>{driver.displayName}</strong></td>
                    <td style={styles.td}>{driver.contact}</td>
                    <td style={styles.td}><VerificationBadge driver={driver} theme={theme} /></td>
                    <td style={styles.td}>{driver.displayWallet}</td>
                    <td style={styles.td}>
                      <button style={styles.viewMoreBtn} onClick={() => handleViewMoreClick(driver)}>
                        <ViewMoreIcon /> View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div style={styles.pagination}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{ fontSize: "10px", color: colors.textMuted }}>
                {loading ? "Loading..." : `Showing ${startIndex + 1}–${Math.min(startIndex + perPage, totalFiltered)} of ${totalFiltered} drivers`}
              </span>
              
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "10px", color: colors.textMuted }}>Rows:</span>
                <select 
                  value={perPage} 
                  onChange={handlePerPageChange}
                  style={styles.rowsPerPageSelect}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                </select>
              </div>
            </div>
            
            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
              {/* First Page */}
              <button 
                onClick={goToFirstPage} 
                disabled={page === 1 || loading} 
                style={{ 
                  width: "26px", height: "26px", borderRadius: "5px", 
                  border: `1px solid ${colors.border}`, 
                  background: colors.surface, 
                  color: page === 1 ? colors.textMuted : colors.textSecondary, 
                  cursor: "pointer", fontSize: "9px", fontWeight: 700 
                }}
                title="First Page"
              >
                ««
              </button>
              
              {/* Previous */}
              <button 
                onClick={() => setPage(p => Math.max(1, p - 1))} 
                disabled={page === 1 || loading} 
                style={{ width: "26px", height: "26px", borderRadius: "5px", border: `1px solid ${colors.border}`, background: colors.surface, color: page === 1 ? colors.textMuted : colors.textSecondary, cursor: "pointer", fontSize: "10px" }}
              >
                <ChevronLeftIcon />
              </button>
              
              {/* Page Numbers */}
              {renderPageNumbers()}
              
              {/* Next */}
              <button 
                onClick={() => setPage(p => Math.min(totalPages, p + 1))} 
                disabled={page === totalPages || loading} 
                style={{ width: "26px", height: "26px", borderRadius: "5px", border: `1px solid ${colors.border}`, background: colors.surface, color: page === totalPages ? colors.textMuted : colors.textSecondary, cursor: "pointer", fontSize: "10px" }}
              >
                <ChevronRightIcon />
              </button>
              
              {/* Last Page */}
              <button 
                onClick={goToLastPage} 
                disabled={page === totalPages || loading || totalPages === 0} 
                style={{ 
                  width: "26px", height: "26px", borderRadius: "5px", 
                  border: `1px solid ${colors.border}`, 
                  background: colors.surface, 
                  color: (page === totalPages || totalPages === 0) ? colors.textMuted : colors.textSecondary, 
                  cursor: (page === totalPages || totalPages === 0) ? "not-allowed" : "pointer", 
                  fontSize: "9px", fontWeight: 700 
                }}
                title="Last Page"
              >
                »»
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {confirmDelete && (
        <div onClick={() => setConfirmDelete(false)} style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.modalBg, border: `1px solid ${colors.modalBorder}`, borderRadius: "12px", padding: "20px", width: "320px" }}>
            <h3 style={{ margin: "0 0 8px", fontSize: "14px", color: colors.textPrimary }}>Confirm Delete</h3>
            <p style={{ fontSize: "12px", color: colors.textSecondary, marginBottom: "16px" }}>
              Delete {selected.size} driver{selected.size > 1 ? "s" : ""}? This cannot be undone.
            </p>
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={() => setConfirmDelete(false)} style={{ flex: 1, padding: "8px", borderRadius: "6px", border: `1px solid ${colors.border}`, background: colors.surfaceLighter, color: colors.textSecondary, cursor: "pointer", fontSize: "11px" }}>Cancel</button>
              <button onClick={handleDeleteSelected} disabled={actionLoading} style={{ flex: 1, padding: "8px", borderRadius: "6px", border: "none", background: colors.deleteBg, color: colors.deleteColor, cursor: "pointer", fontSize: "11px" }}>
                {actionLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} theme={theme} />}
    </div>
  );
};

export default DriverTable;